import { useEffect, useState } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import { updateRegionAction } from 'features/regions/redux/actions';
import type { EditRegionModalProps } from './types';
import { RegionModalFooter } from '../ModalFooter';
import { RegionForm } from '../../Form/Region';

export const EditRegionModal = (props: EditRegionModalProps) => {
  const [form] = useAppForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { selectedRegion } = useAppSelector((state) => state.regionsState);

  useEffect(() => {
    if (props.visible && selectedRegion) {
      form.setFieldsValue({ ...selectedRegion });
    }
  }, [props.visible, selectedRegion]);

  const hideModal = () => {
    form.resetFields();
    props.hide();
  };

  const onSubmit = () => {
    if (!selectedRegion) return;

    form.validateFields().then((values) => {
      setLoading(true);

      dispatch(
        updateRegionAction({
          ...selectedRegion,
          ...values,
        }),
      )
        .unwrap()
        .then(() => {
          hideModal();
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const footer = <RegionModalFooter hideModal={hideModal} onSubmit={onSubmit} title="Сохранить" />;
  const content = <RegionForm form={form} />;

  return (
    <AppModal
      visible={props.visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Редактировать регион"
      maskClosable={false}
    />
  );
};
